<template>
  <div class="projects-list" v-if="current.cxcpedidoe_set">
    <div
      style="cursor: pointer; background-color: #676767; border-radius: 5px"
      class="text-center"
    >
      <hr />
      <h5 class="text-center text-light">
        Pedidos Asignados # {{ current.cantidad_pedidos }}
      </h5>
      <hr />
    </div>
    <div
      class="project-box"
      v-for="det in current.cxcpedidoe_set"
      v-bind:key="det.id"
      @click="rowClick(det)"
    >
      <div style="cursor: pointer; background-color: #ccc0f4">
        <div class="project-head">
          <div class="project-title">
            <h5># {{ det.numero }}</h5>
            <small class="font-weight-bold badge badge-success">{{
              det.estado_str
            }}</small>
            <br />
            <small class="font-weight-bold">{{ det.fecha }}</small>
            <br />
            <small class="font-weight-bold">Tienda: {{ det.tienda }}</small>
          </div>
        </div>
        <div
          style="background-color: #eaebff; padding-right: 1px; padding-left: 1px"
          class="project-info"
        >
          <div class="row align-items-center">
            <div class="col-12">
              <div class="row">
                <div class="col-6">
                  <div class="el-tablo highlight text-center">
                    <div v-if="det" class="label" style="color: black">Cliente</div>
                    <h6 style="color: #25a007">
                      <small>{{ det.cliente_nombre }} - {{ det.cliente_nit }}</small>
                    </h6>
                  </div>
                </div>
                <div class="col-6">
                  <div class="el-tablo highlight text-center">
                    <div class="label" style="color: black">Dirección</div>
                    <div class="value">
                      <h6 style="color: #25a007">
                        <small>{{ det.cliente_direccion }}</small>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="project-foot"></div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="opciones"
      role="dialog"
      tabindex="-1"
      style="padding-right: 15px; backdrop-filter: blur(5px);"
    >
      <div class="modal-dialog modal-centered fade animated" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cerrar</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-media">
            <img alt="" src="img/bigicon2.png" width="200px" />
          </div>
          <div class="onboarding-content with-gradient">
            <h4 class="onboarding-title">Opciones</h4>
            <br />
            <div @click="desasignarPedidoViaje(currentDetalle)" class="onboarding-text">
              <button class="btn btn-outline-danger btn-block">
                Quitar Pedido <i class="fas fa-trash-alt"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";
import Notifications from "@/notifications/notifications";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
  },
  components: {
    PaginationComponent,
  },
  data() {
    return {
      currentDetalle: {},
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
      date: "",
    };
  },
  computed: {},
  mounted() {},
  methods: {
    desasignarPedidoViaje(det) {
      DynamicService.postAction(
        "cat",
        "viajes-reparto",
        this.current.id,
        "desagninar_pedido_viaje",
        { id: det.id }
      )
        .then((responde) => {
          Notifications.alert.success(
            "Desasignar pedido a viaje",
            "Realizado Exitosamente"
          );
          $("#opciones").modal("hide");
          this.$emit("refresh", {});
        })
        .catch((errors) => {
          Notifications.alert.error(
            "Desasignar pedido a viaje",
            errors.response.data.detail
          );
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("recepciones/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
    irAEsconderModal(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      this.$router.push({
        name: name,
        params: params,
      });
    },
    rowClick(detalle) {
      let self = this;
      if (this.current.estado != "A") {
        return;
      }
      $("#opciones").modal("show");
      self.currentDetalle = detalle;
    },
    eliminarDetalle(current) {
      let self = this;
      Notifications.alert.confirm(
        "tarima",
        "¿Esta seguro de eliminar la tarima del contenedor",
        "Si Eliminar",
        function () {
          ContenedorService.remover_tarima_a_contenedor(self.current.id, {
            tarima_barra: current.barra,
          })
            .then((response) => {
              Notifications.alert.success("tarima", "Se ha eliminado la Información.");
              self.$emit("refresh", {});
            })
            .catch((error) => {
              Vue.nextTick(function () {
                if ("detail" in error.response.data) {
                  Notifications.alert.error("Error", error.response.data.detail);
                }
              });
            });
        }
      );
    },
  },
};
</script>
